import { useQuery } from 'react-query';
import { getNotificationsNumber } from 'src/services/notification';

export const useNotificationsNumber = () => {
  return useQuery('nots-number', () => getNotificationsNumber());
};
